import { SdkContext } from '../internal'
import type { Section, MenuCounters } from '@/types/sections'

export class SectionsResource {
  constructor(private ctx: SdkContext) {}

  async list(params: Record<string, unknown> = {}) {
    return this.ctx.call<Section[] | null>({ httpMethod: 'GET', path: '/sections' }, { query: params })
  }

  async get(id: string) {
    return this.ctx.call({ httpMethod: 'GET', path: `/sections/{id}` }, { id })
  }

  async create(sectionData: Record<string, unknown>) {
    return this.ctx.call({ httpMethod: 'POST', path: '/sections', hasBody: true }, { body: sectionData })
  }

  async update(id: string, sectionData: Record<string, unknown>) {
    return this.ctx.call(
      { httpMethod: 'PUT', path: `/sections/{id}`, hasBody: true },
      { id, body: sectionData }
    )
  }

  async delete(id: string): Promise<void> {
    return this.ctx.call({ httpMethod: 'DELETE', path: `/sections/{id}` }, { id })
  }

  /** F-191 phase 2b: what is new since the last visit, per space and per section, for the whole menu. */
  async menuCounters() {
    return this.ctx.call<MenuCounters>({ httpMethod: 'GET', path: '/menu/counters' })
  }

  async reorderSections(sections: Array<{ id: string; order: number }>) {
    return this.ctx.call(
      { httpMethod: 'POST', path: '/sections/reorder', hasBody: true },
      { body: { sections } }
    )
  }
}
